module.exports = __webpack_public_path__ + "img/3dffe12aa546832b92c46efd5b42eb35.png";